export enum ReviewStatus {
    discard = "discard",
    complete = "complete",
    inProgress = "inProgress"
}

export interface IReviewer {
    reviewer: string,
    status: ReviewStatus
}